import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "@/components/BrandMark";

export default function PricingCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="pricing-cancel-page">
      <div className="max-w-md text-center">
        <div className="flex justify-center">
          <BrandMark className="text-2xl opacity-80" signOnMount={false} testid="pricing-cancel-brand" />
        </div>
        <h1 className="font-display text-3xl mt-4">No harm done.</h1>
        <p className="mt-3 text-sm text-[hsl(var(--muted-foreground))]">
          Payment was cancelled — nothing was charged. The rest of your practice stays yours.
        </p>
        <Link to="/" className="mt-6 inline-block rounded-full px-5 py-2.5 bg-[hsl(var(--fg))] text-[hsl(var(--paper))] text-sm hover:opacity-90 tab-link">
          Back to Home
        </Link>
      </div>
    </div>
  );
}
